
















































import { Component, Vue, Ref, Watch } from "vue-property-decorator";
import TemplatesList from "@/views/TemplatesList.vue";
import ConfigurationScene from "@/views/ConfigurationScene.vue";
import Loading from "@/components/loading/Loading.vue";
import TemplatesModule from "@/store/modules/templates";
import Template from "@/models/template";
import { messager, Messager } from "@/models/messager.ts";
import SvgIcon from "@/components/SvgIcon.vue";

@Component({
  components: {
    TemplatesList,
    ConfigurationScene,
    Loading,
    SvgIcon,
  },
  name: "App",
})
export default class Configurator extends Vue {
  public loadingMessages: string[] = [];
  public loadingCanCancel: boolean = false;
  private snackbar: boolean = true;
  private messager: Messager = messager;

  get isLoading() {
    return this.loadingMessages.length !== 0;
  }

  get tinyClass() {
    return this.$store.getters.configuration.tiny === "true"
      ? "tiny-creative"
      : "";
  }

  get loadingMessage() {
    return this.loadingMessages[0];
  }

  get templateChooseStep(): boolean {
    return TemplatesModule.selectedTemplate == null;
  }

  private onBackPressed() {
    TemplatesModule.setSelectedTemplate(null);
  }

  private onLoadingChanged(message: string, loading: boolean) {
    const index = this.loadingMessages.indexOf(message);

    if (loading) {
      if (index < 0) {
        this.loadingMessages.push(message);
      }
    } else {
      this.loadingMessages.splice(index, 1);
    }
  }

  private created() {
    this.$store.subscribe((mutation, state) => {
      if (
        mutation.type === "showLoadingScreen" ||
        mutation.type === "hideLoadingScreen"
      ) {
        const message = this.$store.getters.scene.loadingMessage;
        const loading = message.length > 0;
        this.onLoadingChanged(message, loading);
      }
    });

    this.$store.commit("showLoadingScreen", "");
    // (this.$api.getSapConfig().then(
    //   elements => {
    //     this.$store.commit('setSapElements', elements)
    //   },
    //   error => {}
    // ) as any).finally(() => {});
  }
}
